import RouterErrorBox from "components/RouterErrorBox";
import type { NonIndexRouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { insolvencyMonitorRoute } from "./insolvency-monitor/route";
import { liquidatorRoute } from "./liquidator/route";
import { priceMonitorRoute } from "./price-monitor/route";
import WhitelistRootRoute from "./WhitelistRootRoute";

export const whitelistRoute: NonIndexRouteObject = {
  element: <WhitelistRootRoute />,
  errorElement: <RouterErrorBox />,
  children: [
    {
      index: true,
      element: <Navigate to="liquidator" replace={true} />,
    },
    {
      path: "liquidator",
      ...liquidatorRoute,
    },
    {
      path: "price-monitor",
      ...priceMonitorRoute,
    },
    {
      path: "insolvency-monitor",
      ...insolvencyMonitorRoute,
    },
  ],
};
